(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["e-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    document.querySelectorAll('[data-phone]').forEach(input => {
      if (input.dataset.initialized) return;
      input.dataset.initialized = 'true';
      const validate = () => {
        const normalized = input.value.replace(/[٠-٩]/g, c => String(c.charCodeAt(0) - 1632)).replace(/[۰-۹]/g, c => String(c.charCodeAt(0) - 1776)).replace(/[\s().\-\u200e\u200f]/g, '');
        const valid = !normalized || /^(?:0[567]\d{8}|(?:\+212|00212)[567]\d{8})$/.test(normalized);
        input.setCustomValidity(valid ? '' : input.dataset.phoneError);
        input.setAttribute('aria-invalid', String(!valid));
      };
      input.addEventListener('input', validate);
      input.addEventListener('blur', validate);
    });
    const selector = document.getElementById('EversaVariant');
    if (selector && !selector.dataset.initialized) {
      selector.dataset.initialized = 'true';
      selector.addEventListener('change', () => {
        const option = selector.selectedOptions[0];
        const price = document.querySelector('[data-product-price] bdi');
        const button = document.querySelector('[data-product-submit]');
        if (price) price.textContent = option.dataset.price;
        const quantity = document.getElementById('EversaQuantity');
        if (quantity) {
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        if (button && button.dataset.ready === 'true') {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? button.dataset.unavailable : button.dataset.add;
        }
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
